import React, { Fragment } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Authenticate from './components/Authenticate';
import Branches from './pages/Branches';
import Categories from './pages/Categories';
import Comparison from './pages/Comparison';
import Heatmap from './pages/Heatmaps';
import Home from './pages/Home';
import Insights from './pages/Insights';
import Layout from './pages/Layout';
import Login from './pages/Login';
import NoMatch from './pages/NoMatch';
import Sales from './pages/Sales';
import Settings from './pages/Settings';
import ResetPassowrd from './pages/Templates/ResetPassowrd';
import Users from './pages/Users';
import Visitors from './pages/Visitors';
import Conversion from './pages/conversions/Conversion';
import EmployeActivity from './pages/EmployeActivity';


function App() {
  return (
    <Fragment>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path={'/reset-password/:token'} element={<ResetPassowrd />} />
          <Route path="/" element={<Authenticate><Layout /></Authenticate>}>
            <Route path={'/settings'} element={<Settings />} />
            <Route path={'/sales'} element={<Sales />} />
            <Route path={'/traffic'} element={<Visitors />} />
            <Route path={'/insights'} element={<Insights />} />
            <Route path={'/comparison'} element={<Comparison />} />
            <Route path={'/categories'} element={<Categories/>} />
            <Route path={'/heatmap'} element={<Heatmap />} />
            <Route path={'/settings'} element={<Settings />} />
            <Route path={'/users'} element={<Users />} />
            <Route path={'/branches'} element={<Branches />} />
            <Route index element={<Home />} />
            <Route path={'/conversions/:id/:title'} element={<Conversion />} />
            <Route path={'/employe-activity'} element={<EmployeActivity />} />
          </Route>
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </Router>
    </Fragment>
  );
}

export default App;